import { axiosGetHandler } from './config';

// 获取分享信息
export function getShareInfo(args) {
  let url = '/game/wx_share/info/v2';
  return axiosGetHandler(url, args);
}
